module.exports = __webpack_public_path__ + "static/media/AuraPayLogo.f43fa965.png";